import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'week',
  pure: false,
  standalone: true
})
export class WeekPipe implements PipeTransform {
  transform(date: Date | DateTime): number {
    const value = date instanceof DateTime ? date : DateTime.fromJSDate(date);
    return value.weekNumber;
  }
}
